(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[id^="VenusHeader-"]').forEach((header) => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 10) {
        header.classList.add('venus_new_menu_header_scrolled');
      } else {
        header.classList.remove('venus_new_menu_header_scrolled');
      }
    });
  });

  document.querySelectorAll('[id^="VenusMobileMenuBtn-"]').forEach((btn) => {
    const id = btn.id.replace('VenusMobileMenuBtn-', '');
    const menu = document.getElementById('VenusMobileMenu-' + id);
    const closeBtn = document.getElementById('VenusMobileMenuClose-' + id);

    btn.addEventListener('click', () => {
      menu.classList.remove('venus_new_menu_mobile_menu_closed');
      menu.classList.add('venus_new_menu_mobile_menu_open');
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        menu.classList.remove('venus_new_menu_mobile_menu_open');
        menu.classList.add('venus_new_menu_mobile_menu_closed');
      });
    }
  });

  document.querySelectorAll('[data-venus-accordion-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const targetId = button.getAttribute('data-target');
      const body = document.getElementById(targetId);
      const icon = document.querySelector('[data-venus-accordion-icon="' + targetId + '"]');

      if (body.classList.contains('venus_new_menu_is_hidden')) {
        body.classList.remove('venus_new_menu_is_hidden');
        if (icon) icon.textContent = 'expand_less';
      } else {
        body.classList.add('venus_new_menu_is_hidden');
        if (icon) icon.textContent = 'expand_more';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
